module.exports = __webpack_public_path__ + "img/DIENTEBUENO.5f1dedbc.png";